import { CodeNameType } from 'components/common/types/AssetList.types';
import AsyncSelect from 'lib/AsyncSelect';
import { AsyncSelectLoadDataHandler, SelectHandler } from 'lib/AsyncSelect/AsyncSelect.types';
import { cancelFunctions } from 'utils/cancelFunctions';
import { getChannels } from 'modules/api/inventory';
import { formatFilterOptionsName } from 'utils/formatters';
import { FilterChannelProps } from './FilterChannel.types';

const FilterChannel: React.FC<FilterChannelProps> = ({ changeFilters, channel }) => {
  const fetchFilterOptions = async (query: string): Promise<CodeNameType[]> => {
    if (query.length >= 3) {
      try {
        return await getChannels(cancelFunctions, query);
      } catch (error) {
        return [];
      }
    }
    return [];
  };

  const loadFilterOptions: AsyncSelectLoadDataHandler<CodeNameType> = async (_, query) => {
    return formatFilterOptionsName(await fetchFilterOptions(query));
  };

  const onSelect: SelectHandler<CodeNameType> = (_, value: CodeNameType) => {
    changeFilters({ channel: value });
  };

  return (
    <AsyncSelect
      dataTestId="channel-input"
      name="channel"
      loadData={loadFilterOptions}
      onSelect={onSelect}
      placeholder="Select channel"
      selectedValue={channel}
    />
  );
};

export default FilterChannel;
